import { render, staticRenderFns } from "./periodList.vue?vue&type=template&id=34f1ad58&scoped=true&"
import script from "./periodList.vue?vue&type=script&lang=js&"
export * from "./periodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f1ad58",
  null
  
)

export default component.exports